export const SITE = {
  name: "Cleansof",
  city: "Roma",
  phone: "+39 351 953 3674",
  phoneHref: "+393519533674",
  whatsapp: "393519533674",
  email: "",
  tagline: "Pulizie professionali e noleggio biancheria per case vacanza a Roma.",
};

export const whatsappLink = (text = "Ciao Cleansof, vorrei informazioni per la mia casa vacanza.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const SERVICES = [
  {
    id: "pulizie",
    num: "01",
    title: "Pulizie Case Vacanza",
    short: "Pulizie professionali tra un ospite e l'altro, sempre puntuali.",
    desc: "Interventi accurati calibrati sui tempi del turnover: superfici, bagni, cucina e ambienti riportati a uno standard impeccabile prima di ogni nuovo check-in.",
    img: "https://images.pexels.com/photos/6466212/pexels-photo-6466212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "biancheria",
    num: "02",
    title: "Noleggio Biancheria",
    short: "Lenzuola e asciugamani di qualità hotel, sempre freschi.",
    desc: "Set completi di biancheria in cotone premium consegnati e ritirati da noi. Nessun magazzino da gestire, nessun capo da lavare: solo tessuti impeccabili ad ogni soggiorno.",
    img: "https://images.pexels.com/photos/19743644/pexels-photo-19743644.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "sanificazione",
    num: "03",
    title: "Sanificazione",
    short: "Igienizzazione profonda con prodotti certificati.",
    desc: "Protocolli di sanificazione professionale per garantire ambienti sicuri e salubri, con particolare attenzione ai punti di contatto e agli spazi condivisi.",
    img: "https://images.pexels.com/photos/31902663/pexels-photo-31902663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "checkin",
    num: "04",
    title: "Check-in & Check-out",
    short: "Accoglienza ospiti e verifica dell'immobile.",
    desc: "Gestiamo l'ingresso e l'uscita degli ospiti, la consegna delle chiavi e il controllo dello stato dell'appartamento, con report puntuale al proprietario.",
    img: "https://images.unsplash.com/photo-1593290765072-a1155c1b8976?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    id: "lavanderia",
    num: "05",
    title: "Gestione Lavanderia",
    short: "Lavaggio, stiratura e logistica dei tessuti.",
    desc: "Ci occupiamo dell'intero ciclo della biancheria — ritiro, lavaggio industriale, stiratura e riconsegna — così la tua struttura è sempre pronta ad accogliere.",
    img: "https://images.pexels.com/photos/31902663/pexels-photo-31902663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const ZONES = [
  "Centro Storico", "Trastevere", "Prati", "Monti", "Testaccio",
  "San Giovanni", "Esquilino", "Parioli", "Aventino", "Ostiense",
  "Flaminio", "EUR",
];
